import { stringEmDash } from "@/constants/app_constants";
import BaseTooltip from "@/components/tooltip/Tooltip";
import { CSSProperties } from "react";

export const formatNumberWithDecimalPlaces = (value: number = 0, decimalPlaces: number = 2): number => {
  if (Number.isInteger(value)) {
    return value;
  }

  return Number(value.toFixed(decimalPlaces));
};

interface RenderWithFallbackProps {
  data: string | string[] | number | null | undefined;
  isAntdTable?: boolean;
}

export const createOnCellFunction = (maxWidth: number) => {
  return () => ({
    style: {
      whiteSpace: "nowrap",
      maxWidth: maxWidth
    } as CSSProperties
  });
};

export const RenderWithFallback = ({ data }: RenderWithFallbackProps) => {
  if (data === "" || data === null || data === undefined || (Array.isArray(data) && data.length === 0)) {
    return stringEmDash;
  }

  if (typeof data === "number") {
    return formatNumberWithDecimalPlaces(data);
  }

  if (typeof data === "string") {
    return <BaseTooltip title={data}>{<div style={{ textOverflow: "ellipsis", overflow: "hidden" }}>{data}</div>}</BaseTooltip>;
  }

  return data;
};
